var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-625.000000, -304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_cv",
    transform: "translate(625.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "curriculum-vitae",
    transform: "translate(4.000000, 3.000000)",
    fill: "#1A73E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.5060964 1.13597852 10.427997 0 0 0.750091797 0.984130977 15.0645566 1.9254793 14.9968223 1.9254793 2.65017383 13.3536751 2.65017383 13.3536751 15.8823828 14.4980625 16.0083887 16 1.74110547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89996957,3.64696484 L2.89996957,17 L12.3792173,17 L12.3792173,3.64696484 L2.89996957,3.64696484 Z M6.02284393,5.91965234 C6.62361892,5.91965234 7.09718204,6.14393945 7.39974438,6.54758984 L6.74638372,7.14411719 C6.56658619,6.91086523 6.35176401,6.77629297 6.07549451,6.77629297 C5.64575277,6.77629297 5.35636932,7.08129688 5.35636932,7.56121484 C5.35636932,8.04113281 5.64578523,8.34613672 6.07549451,8.34613672 C6.35176401,8.34613672 6.56661865,8.21156445 6.74638372,7.9783125 L7.39974438,8.57483984 C7.09718204,8.97849023 6.62358646,9.20277734 6.02284393,9.20277734 C5.03621351,9.20277734 4.31270617,8.5255 4.31270617,7.56114844 C4.31270617,6.59692969 5.03624597,5.91965234 6.02284393,5.91965234 Z M10.8173906,14.893959 L4.46176381,14.893959 L4.46176381,13.897168 L10.8173906,13.897168 L10.8173906,14.893959 L10.8173906,14.893959 Z M10.8173906,13.1209453 L4.46176381,13.1209453 L4.46176381,12.1241543 L10.8173906,12.1241543 L10.8173906,13.1209453 L10.8173906,13.1209453 Z M10.8173906,11.3479316 L4.46176381,11.3479316 L4.46176381,10.3511406 L10.8173906,10.3511406 L10.8173906,11.3479316 L10.8173906,11.3479316 Z M9.68001461,9.1311582 L8.66267676,9.1311582 L7.36471973,5.9914043 L8.47852955,5.9914043 L9.21083362,7.82591016 L9.96069871,5.9914043 L10.9779716,5.9914043 L9.68001461,9.1311582 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvIcon);
export default __webpack_public_path__ + "static/media/cv-icon.65d0b5959eec370d276e507000d2c992.svg";
export { ForwardRef as ReactComponent };